import React from 'react';

// eslint-disable-next-line no-unused-vars
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';

import { withMediaQueries } from 'hoc/withMediaQueries';
import MainFont from 'ui/typography/mainFont';

import {
  HistoryDate,
  HistoryListContainer,
  HistoryNote,
  HistoryRow,
  HistoryRowsContainer,
  HistorySideButton,
  HistoryStatus,
  ListTitle,
  NoUpdate,
  SideButtonContainer
} from './style';
import { IconBack } from '../CrudLayout/style';
import { StatusForHistory } from 'const';
import moment from 'moment';

const HistoryList = ({ closeAction, leadHistory = [] }) => {
  const { t } = useTranslation();

  const handleOnClick = () => {
    if (closeAction) {
      closeAction(true);
    }
  };

  const noUpdate = () => {
    return (
      <NoUpdate>
        <MainFont type="4" configuration={{ fontSize: 24, lineHeight: 1.33 }}>
          {t('no_update')}
        </MainFont>
        <MainFont configuration={{ fontSize: 16, lineHeight: 1.33 }}>
          {t('history_list_here')}
        </MainFont>
      </NoUpdate>
    );
  };

  return (
    <HistoryListContainer>
      <SideButtonContainer>
        <HistorySideButton onClick={handleOnClick}>
          <IconBack className="icon-up" />
        </HistorySideButton>
      </SideButtonContainer>
      <ListTitle>
        <MainFont type="bold" configuration={{ fontSize: 16 }}>
          {t('history_list')}
        </MainFont>
      </ListTitle>
      {leadHistory.filter(item => item.Field !== 'created').length ? (
        <HistoryRowsContainer>
          {leadHistory
            .filter(item => item.Field !== 'created')
            .map(item => {
              return (
                <HistoryRow>
                  <HistoryDate>
                    <MainFont
                      configuration={{ fonySize: 12, lineHeight: 1.33 }}
                    >
                      {moment(item.CreatedDate).isValid()
                        ? moment(item.CreatedDate).format('DD/MM/YY HH:mm')
                        : '-'}
                      {` - ${t('updated_by')} ${
                        !item?.CreatedBy?.Name
                          ? '-'
                          : item?.CreatedBy?.Name === 'Dealer'
                          ? t('dealer')
                          : t('f2mes_operator')
                      }`}
                    </MainFont>
                  </HistoryDate>

                  {item.Field === 'Status' ? (
                    <HistoryNote flex>
                      <MainFont
                        type="4"
                        configuration={{ fonySize: 16, lineHeight: 1.5 }}
                      >
                        {`${t('status')} `}
                      </MainFont>
                      <MainFont
                        configuration={{ fonySize: 16, lineHeight: 1.5 }}
                      >
                        {` ${t('changed_from')} `}
                      </MainFont>
                      <HistoryStatus value={StatusForHistory[item?.OldValue]}>
                        {t(StatusForHistory[item?.OldValue])}
                      </HistoryStatus>
                      <MainFont
                        configuration={{ fonySize: 16, lineHeight: 1.5 }}
                      >
                        {t('to')}
                      </MainFont>
                      <HistoryStatus value={StatusForHistory[item?.NewValue]}>
                        {t(StatusForHistory[item?.NewValue])}
                      </HistoryStatus>
                    </HistoryNote>
                  ) : (
                    <HistoryNote>
                      <MainFont
                        type="4"
                        configuration={{ fonySize: 16, lineHeight: 1.5 }}
                      >
                        {`${t('additional_note')} `}
                      </MainFont>
                      <MainFont
                        configuration={{ fonySize: 16, lineHeight: 1.5 }}
                      >
                        {`${t('been_updated')} "${item.NewValue || '-'}"`}
                      </MainFont>
                    </HistoryNote>
                  )}
                </HistoryRow>
              );
            })}
        </HistoryRowsContainer>
      ) : (
        noUpdate()
      )}
    </HistoryListContainer>
  );
};

HistoryList.propTypes = {
  closeAction: PropTypes.func
};

export default withMediaQueries(HistoryList);
